const draftAutosaveIndicatorStyles = {
  //fixed width so the centered drawer title does not shift when the label changes
  root: {
    width: "11rem",
    alignItems: "center",
  },
};

export default draftAutosaveIndicatorStyles;
